/**
 * Cấu hình chung của website (thông tin chủ sở hữu, social links, Firebase).
 * Mọi nơi cần thông tin site đều đọc từ đây thay vì hardcode rải rác.
 */

export const SITE = {
    name: 'Bùi Tiến Tuân',
    shortName: 'Bui Tien Tuan',
    tagline: 'Những ứng dụng nhỏ tôi viết để giải quyết một việc cụ thể — rồi để lại đây cho ai cần.',
    logo: '/image/4T_CIRCLE_PNG_500x500.png',
    startYear: 2022,
};

/** Tài khoản GitHub. Dùng lại ở hero trang chủ và ở danh sách social. */
export const GITHUB_URL = 'https://github.com/TuanBT';

export const SOCIAL_LINKS = [
    { id: 'github', label: 'GitHub', url: GITHUB_URL },
    { id: 'youtube', label: 'YouTube', url: 'https://www.youtube.com/@buitientuan91' },
    { id: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/buitientuan/' },
    { id: 'linkedin', label: 'LinkedIn', url: 'https://www.linkedin.com/in/tu%C3%A2n-b%C3%B9i-ti%E1%BA%BFn-2261a7148/' },
];

/** Chỉ email này mới có quyền vào trang quản trị. */
export const ADMIN_EMAIL = 'bttvn.4t@gmail.com';

export const FIREBASE_CONFIG = {
    apiKey: 'AIzaSyBuALHJjUb535qTv0Usi0tzYodzLdf0VMI',
    authDomain: 'buitientuan-1991.firebaseapp.com',
    databaseURL: 'https://buitientuan-1991-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'buitientuan-1991',
    storageBucket: 'buitientuan-1991.firebasestorage.app',
    messagingSenderId: '847274748591',
    appId: '1:847274748591:web:f6d7aa026d9f8bb427825a',
};

/** Node chứa danh sách ứng dụng trên Realtime Database. */
export const APPS_DB_PATH = '/apps';
